import { render, staticRenderFns } from "./InventarioSingleTrees.vue?vue&type=template&id=6a23a7ce&scoped=true"
import script from "./InventarioSingleTrees.vue?vue&type=script&lang=js"
export * from "./InventarioSingleTrees.vue?vue&type=script&lang=js"
import style0 from "../../../css/crud.css?vue&type=style&index=0&id=6a23a7ce&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a23a7ce",
  null
  
)

export default component.exports